export const formatEnum = str => str.split("_").join(" ");
